import { type TreatmentDefinitionDto, useTreatmentDefinition } from "@repo/data-store";
import { createFileRoute } from "@tanstack/react-router";
import { CatalogDefinition, TreatmentRead } from "@/features/catalog";
import { useDefinitionChangePoints, useDefinitionView } from "@/features/catalog/hooks/use-definition-as-of";
import { asOfSearchSchema } from "@/features/catalog/lib/as-of-search";
import { treatmentDefinitionUrlFromRouteId } from "@/features/catalog/lib/treatment-definition-route";

export const Route = createFileRoute("/catalog/treatments/$treatmentId")({
  component: TreatmentDetail,
  validateSearch: asOfSearchSchema,
});

function TreatmentDetail() {
  const { treatmentId } = Route.useParams();
  const { asOf } = Route.useSearch();
  const { permissions } = Route.useRouteContext();
  const definitionUrl = treatmentDefinitionUrlFromRouteId(treatmentId);
  const live = useTreatmentDefinition(asOf ? undefined : definitionUrl);
  const view = useDefinitionView<TreatmentDefinitionDto>(definitionUrl, asOf, live);
  const { changePoints } = useDefinitionChangePoints(definitionUrl);

  if (view.isPending) return <CatalogDefinition.Pending />;
  if (!view.definition) {
    return <CatalogDefinition.NotFound label="Treatment" backTo="/catalog/procedures" backLabel="Back to procedures" />;
  }

  return (
    <TreatmentRead
      key={`${treatmentId}|${asOf ?? "latest"}`}
      definition={view.definition}
      treatmentId={treatmentId}
      asOf={asOf}
      changePoints={changePoints}
      canEdit={!view.isPast && permissions.canWrite("ActivityDefinition")}
    />
  );
}
